export type HttpError = Error & {
  status?: number;
};

export const parseErrorMessage = (text: string, fallback: string) => {
  const trimmed = `${text || ""}`.trim();
  if (!trimmed.length) {
    return fallback;
  }
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed?.message) {
      return parsed.message;
    }
    if (parsed?.error) {
      return parsed.error;
    }
  } catch (_jsonParseError) {
    // Use the raw text when it is not JSON.
  }
  return trimmed;
};

export const fetchJson = async <T = any>(
  url: string,
  init?: RequestInit,
): Promise<T> => {
  const res = await fetch(url, {
    credentials: "include",
    ...init,
  });

  if (!res.ok) {
    let message = `${res.status}`;
    try {
      message = parseErrorMessage(await res.text(), message);
    } catch (_textError) {
      // Keep status fallback.
    }

    const error = new Error(message) as HttpError;
    error.status = res.status;
    throw error;
  }

  return res.json();
};
